import { Fab, useMediaQuery } from '@mui/material';
import React from 'react';
import theme from '../../config/theme';

type PropsTypes = {
  Icon?: any;
  onClick?: any;
  iconSizeMobile?: any;
  iconSizeDesktop?: any;
  disabled?: boolean;
  background?: string;
  color?: string;
};

export default function FabControlled(props: PropsTypes) {
  const {
    Icon,
    onClick,
    iconSizeMobile = '1rem',
    iconSizeDesktop = theme.spacing(4),
    disabled = false,
    background = theme.palette.primary.contrastText,
    color,
  } = props;

  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('lg'));

  return (
    <Fab
      disabled={disabled}
      onClick={onClick}
      size={isMobile ? 'small' : 'large'}
      sx={{
        '&:hover': {
          background,
        },
        background,
        boxShadow: 'none',
        width: 50,
        height: 50,
        minHeight: 36,
        [theme.breakpoints.down('lg')]: {
          width: 30,
          height: 30,
          minHeight: 30,
        },
      }}
    >
      <Icon
        sx={{
          color: color ? color : 'white',
          fontSize: iconSizeDesktop,
          [theme.breakpoints.down('lg')]: {
            fontSize: iconSizeMobile,
          },
          '&:hover': {
            color: color ? color + ' !important' : 'white',
          },
        }}
      />
    </Fab>
  );
}
